import { fetchData } from './fetch-data';

export async function getScheduling(slug: string, apiUrl: string) {
  try {
    const schedulingData = await fetchData(apiUrl, `public/scheduling/${slug}`, 'GET');
    return schedulingData;
  } catch (error) {
    console.error('Error fetching scheduling data:', error);
    return null;
  }
}
